<template>
  <v-expansion-panel
    class="mt-0 bg-secondary-o-50 mb-3 rounded-lg"
    @click="togglePanel"
  >
    <v-expansion-panel-header class="ps-0">
      <span class="font-weight-black font-size-lg ms-5">
        <!-- <v-icon class="mr-3">mdi-{{ headerIcon }}-circle-outline</v-icon> -->
        {{ warehouseDetails.text }}
      </span>
    </v-expansion-panel-header>
    <v-expansion-panel-content class="ps-0">
      <div class="ms-5 border-top">
        <div
          v-if="!serverDataLoaded"
          class="d-flex justify-content-center mt-5"
        >
          <v-progress-circular
            :size="50"
            :width="5"
            color="#7e04b7"
            indeterminate
          />
        </div>
        <form v-else-if="serverDataLoaded" class="form-body mt-5">
          <!-- pickup_creation_buffer_minutes -->
          <v-row>
            <v-col md="6">
              <v-text-field
                v-model="formData.pickup_creation_buffer_minutes"
                label="Pickup creation buffer in minutes"
                dense
                outlined
                rounded
                clearable
                type="number"
                :min="0"
                @change="
                  () => validateMinValue('pickup_creation_buffer_minutes')
                "
              />
            </v-col>
          </v-row>
          <!-- Submit -->
          <v-row class="justify-center mb-3">
            <v-col md="2" class="justify-content-end">
              <button
                class="btn btn-info px-5 py-3 ls1"
                @click.prevent="submitConfiguration"
              >
                Submit
              </button>
            </v-col>
          </v-row>
        </form>
      </div>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import { validationMixin } from "vuelidate";
import {
  // required,
  requiredIf,
} from "vuelidate/lib/validators";
import ApiService from "@/core/services/api.service";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Swal from "sweetalert2";
import fieldValueValidation from "@/own/mixins/fieldValueValidation";

export default {
  name: "ExpansionPanel",
  mixins: [validationMixin, fieldValueValidation],
  props: {
    warehouseDetails: { type: Object, required: true },
  },
  components: {},
  data() {
    return {
      expanded: false,
      serverDataLoaded: false,
      defaultStagingLocation: null,
      formData: { pickup_creation_buffer_minutes: null },
    };
  },
  // validations: {
  //   formData: {
  //   },
  // },
  methods: {
    togglePanel: function () {
      if (!this.expanded) {
        this.loadDataFromServer();
      }
      this.expanded = !this.expanded;
    },

    loadDataFromServer: function () {
      this.serverDataLoaded = false;
      const payload = {
        type: "outbound",
        warehouse_id: this.warehouseDetails.index,
      };
      return new Promise((resolve) => {
        ApiService.post(
          `/warehouse_management/main_configuration/create`,
          payload
        )
          .then(({ data }) => {
            this.serverData = data;
            this.setConfigurationData(data.configurations.details);
            this.defaultStagingLocation =
              data.configurations.default_location_id;
            this.serverDataLoaded = true;
            resolve(data);
          })
          .catch();
      });
    },

    setConfigurationData: function (data) {
      this.formData = {
        pickup_creation_buffer_minutes: data[0].value,
      };
    },

    handleFormValidation: function (fieldName, vueObj) {
      const errors = [];
      if (!vueObj.$v.formData[fieldName].$dirty) return errors;
      if ("required" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].required &&
          errors.push("This field is required");
      }
      if ("url" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].url &&
          errors.push("This url is invalid");
      }
      if ("numeric" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].numeric &&
          errors.push("This must be a number");
      }
      if ("email" in vueObj.$v.formData[fieldName]) {
        !vueObj.$v.formData[fieldName].email &&
          errors.push("This email address is invalid");
      }
      return errors;
    },

    submitConfiguration: function () {
      // this.$v.$touch();
      // if (!this.$v.$invalid && !this.stagingLocationError) {
      const data = this.formData;
      const payload = {
        type: "outbound",
        warehouse_id: this.warehouseDetails.index,
        default_location_id: this.defaultStagingLocation,
        configurations: [
          {
            key: "pickup_creation_buffer_minutes",
            value: data.pickup_creation_buffer_minutes,
            apply_rule_type: "all",
            customers: [],
          },
        ],
      };
      this.$store.commit(SET_PAGE_LOADING, true);
      return new Promise(() => {
        ApiService.post(
          `/warehouse_management/main_configuration/store`,
          payload
        )
          .then(() => {
            Swal.fire({
              title: "Updated",
              text: "The Configuration settings are updated",
              icon: "success",
              showConfirmButton: false,
              timer: 2500,
            });
          })
          .catch()
          .finally(() => {
            this.$store.commit(SET_PAGE_LOADING, false);
          });
      });
      // }
    },
  },
  computed: {},
};
</script>
